// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.ef5aefa8',
  revision: 'ef5aefa8',
  branch: 'develop',
  date: 'Thu, 09 Apr 2026 13:02:14 GMT'
};